// extracted by mini-css-extract-plugin
export default {"container":"HomeDetails_container__xEK3v"};